<template>
  <ContentDetailSubHeaderTitle :is-loading="isLoading" />

  <ContentCardsContentCard
    :is-loading="isLoading"
    :skeleton-cards="skeletonCards"
    :show-paging-skeleton="showPagingSkeleton"
    :skeleton-paging-cards="skeletonPagingCards"
    :content-shows="contentShows"
  />

  <ContentDetailButtonLoadMoreContent
    v-if="!showTotalContents"
    :is-loading="isLoading"
    @click="onClickShowTotalContents"
  />
</template>

<script setup lang="ts">
import type { ContentCardModel } from "@/models/ContentCard";

const route = useRoute();
const isLoading = ref(true);
const skeletonCards = 6;
const skeletonPagingCards = 2;
const contents = ref<ContentCardModel[]>([]);
const contentShows = ref<ContentCardModel[]>([]);
const showTotalContents = ref(false);
const showPagingSkeleton = ref(false);
const contentId = route.params.contentid as string;
const cached = useRecommendSessionStorage();

onMounted(async () => {
  const isCacheRecommend = useIsCacheRecommend(
    contentId,
    cached,
    contents,
    contentShows,
  );
  if (isCacheRecommend) {
    showTotalContents.value =
      contentShows.value.length === contents.value.length;
    isLoading.value = false;
    return;
  }

  const contentCards = await useContentRecommend();
  if (contentCards.contents.length === 0) return;

  contents.value = contentCards.contents;
  contentShows.value = contents.value.slice(0, 10);
  isLoading.value = false;

  useCacheRecommend(contentId, cached, contents, contentShows);
});

const onClickShowTotalContents = () => {
  if (isLoading.value) return;

  showTotalContents.value = true;
  showPagingSkeleton.value = true;
  setTimeout(() => {
    showPagingSkeleton.value = false;
    contentShows.value = contents.value;
    useCacheRecommend(contentId, cached, contents, contentShows);
  }, 1000);
};
</script>
